// Utility functions for priority handling
export const getPriorityColor = (priority: number): string => {
  const colors = {
    5: '#ff4d4f',    // CRITIQUE - Rouge
    4: '#fa8c16',    // URGENT - Orange
    3: '#fadb14',    // MOYEN - Jaune
    2: '#1890ff',    // NORMAL - Bleu
    1: '#d9d9d9',    // FAIBLE - Gris
  };
  return colors[priority as keyof typeof colors] || '#d9d9d9';
};

export const getPriorityText = (priority: number): string => {
  const texts = {
    5: 'CRITIQUE',
    4: 'URGENT',
    3: 'MOYEN',
    2: 'NORMAL',
    1: 'FAIBLE',
  };
  return texts[priority as keyof typeof texts] || 'NORMAL';
};

export const getImportanceText = (importance: number): string => {
  const texts = {
    1: 'très faible',
    2: 'faible',
    3: 'moyen',
    4: 'fréquent',
    5: 'très fréquent',
  };
  return texts[importance as keyof typeof texts] || 'moyen';
};

export const getStatusText = (status: string): string => {
  const texts = {
    'DISPO': 'Disponible',
    'DISPO_ANCIEN': 'Disponible Ancien',
    'ATT_CLIENT': 'Attente Client',
    'ATT_EN_LIGNE': 'Attente En Ligne',
    'ATT_VISITEUR': 'Attente Visiteur',
    'ATT_TOPO': 'Attente Topo',
    'PROB': 'Problème',
    'A_DEMANDER_AU_TOPO': 'À Demander au Topo',
    'A_DEMANDER_EN_LIGNE': 'À Demander En Ligne',
  };
  return texts[status as keyof typeof texts] || status;
};